import React from 'react';
import PropTypes from 'prop-types';
import StyledButton from './style';

function CustomButton(props) {
  const { classNames, children, ...other } = props;
  return (
    <StyledButton {...other} className={`custom-ant-button ${classNames}`}>
      {children}
    </StyledButton>
  );
}

CustomButton.defaultPropTypes = {
  size: 'large',
  type: 'primary',
};

CustomButton.propTypes = {
  classNames: PropTypes.string,
  children: PropTypes.any,
};

export default CustomButton;
